import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import Fuse from 'fuse.js';
import { trackActivity } from '../../../../utils/analytics/analyticsService';
import { useGetUserInfoQuery } from '../../../../api/userApi';
import { selectedUserIdSelector } from '../../../../selectors/userSelectors';
import { useGetMacrosQuery } from '../../../../api/macrosApi';
import {
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from '@mui/material';

const Macros = ({ setMacroMessage, isOpen, setIsOpen }) => {
  const [searchQuery, setSearchQuery] = useState('');

  const selectedUserId = useSelector(selectedUserIdSelector);

  const { data: userInfo, isLoading: isUserInfoLoading } = useGetUserInfoQuery(selectedUserId);
  const { data: macros = [], isLoading: areMacrosLoading } = useGetMacrosQuery();

  const fuse = useMemo(() => new Fuse(macros, { keys: ['name', 'text'] }), [macros]);
  const macroOptions = useMemo(() => {
    const searchMatches = searchQuery.trim().length ? fuse.search(searchQuery).map(({ item }) => item) : macros;
    return searchMatches;
  }, [fuse, searchQuery, macros]);

  if (isUserInfoLoading || areMacrosLoading) {
    return null;
  }

  return (
    <Modal
      open={isOpen}
      onClose={() => {
        setIsOpen(false);
      }}
    >
      <Paper sx={{ p: 3, maxWidth: 800, maxHeight: 800, overflow: 'auto', margin: 'auto', marginTop: '10vh' }}>
        <Typography variant='h3'>Macros</Typography>
        <TextField variant='outlined' onChange={(e) => setSearchQuery(e.target.value)} placeholder='Search macros' />
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell width='40%' sx={{ fontSize: '14px' }}>
                  Name
                </TableCell>
                <TableCell width='60%' sx={{ fontSize: '14px' }}>
                  Text
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {macroOptions.map(({ name, text, id }) => (
                <TableRow
                  key={id}
                  hover={true}
                  sx={{
                    cursor: 'pointer',
                    '&:hover': {
                      backgroundColor: 'rgba(0, 0, 0, 0.04)'
                    }
                  }}
                  onClick={() => {
                    setMacroMessage(text);
                    trackActivity('used macro', {
                      macroId: id,
                      macroName: name,
                      macroText: text,
                      userPhone: userInfo.phone
                    });
                    setIsOpen(false);
                  }}
                >
                  <TableCell width='40%'>{name}</TableCell>
                  <TableCell width='60%'>{text}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Modal>
  );
};

export default Macros;
